import { initialState } from '@ispm-client/modules/bpmn-modeler/store/state';
import {
    NodeIdGeneratorAction,
    NodeIdGeneratorActionTypes
} from '@ispm-client/modules/bpmn-modeler/store/actions/node-id-generator.action';

/**
 * Created By Elia Rohana on 3/28/19
 */

export function lastNodeId(state = initialState.lastNodeId, action: NodeIdGeneratorAction): number {
    switch (action.type) {
        case NodeIdGeneratorActionTypes.UPDATE_LAST_NODE_ID: {
            return action.payload.id;
        }
        default: {
            return state;
        }
    }
}
